import { API_JWT_BASE_URL } from '../http'
export const GET_OPTIONAL_DEVICE_APPLICATIONS_API = `${API_JWT_BASE_URL}/DeviceApplications/optionalDeviceApplicationVersion`

export const GET_REQUIRED_DEVICE_APPLICATIONS_API = `${API_JWT_BASE_URL}/DeviceApplications/requiredDeviceApplicationVersion/`

export const SEARCH_DEVICE_APPLICATION_API = `${API_JWT_BASE_URL}/DeviceApplications/search`

export const GET_DEVICE_APPLICATION_API = `${API_JWT_BASE_URL}/DeviceApplications/detail/`

export const IMPORT_DEVICE_APPLICATION_API = `${API_JWT_BASE_URL}/DeviceApplications/import`

export const DELETE_DEVICE_APPLICATION_API = `${API_JWT_BASE_URL}/DeviceApplications/delete`
export const OBSOLETE_DEVICE_APPLICATION_API = `${API_JWT_BASE_URL}/DeviceApplications/obsolete`

export const DEVICE_APPLICATION_QUERY_KEYS = {
  GET_OPTIONAL_DEVICE_APPLICATIONS: 'GET_OPTIONAL_DEVICE_APPLICATIONS',
  GET_REQUIRED_DEVICE_APPLICATIONS: 'GET_REQUIRED_DEVICE_APPLICATIONS',
  SEARCH_DEVICE_APPLICATION: 'SEARCH_DEVICE_APPLICATION',
  GET_DEVICE_APPLICATION: 'GET_DEVICE_APPLICATION',
  IMPORT_DEVICE_APPLICATION: 'IMPORT_DEVICE_APPLICATION',
  DELETE_DEVICE_APPLICATION: 'DELETE_DEVICE_APPLICATION',
  OBSOLETE_DEVICE_APPLICATION: 'OBSOLETE_DEVICE_APPLICATION'
}
